window.crGtag = (function() {

	return {
		track: function(sendTo, value) {
			var data = {
				send_to: sendTo,
				currency: 'USD'
			};

			if (value) {
				data.value = value;
			}

			//console.log('gtag => ' , data);
			if (typeof gtag !== 'undefined') {
				gtag('event', 'conversion', data);
			}
		},

		updateDataLayer: function(data) {
			window.dataLayer.push(data);
		}
	};
})();
